var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition-slide"},[_c('transition',{attrs:{"name":"slide"},on:{"beforeEnter":_vm.beforeEnter,"beforeLeave":_vm.beforeLeave}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }